<template>
  <div class="view-html">
    <Modal v-model="showModal" title="服务协议预览" width="800">
      <div class="view-html-main">
        <div v-html="html"></div>
      </div>
      <div slot="footer">
        <Button @click="handleClose">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import platformApi from '@/request/eduCenter/platform.js'
export default {
  data() {
    return {
      showModal: false,
      html: ''
    }
  },
  methods: {
    handleShow(html) {
      this.html = ''
      this.getServiceAgreementTemplate(html)
      this.showModal = true
    },
    handleClose(content) {
      this.showModal = false
    },
    async getServiceAgreementTemplate(content) {
      let res = await platformApi.getServiceAgreementTemplate({
        content: content
      }
      )
      if (res.status == 200) {
        this.html = res.message
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.view-html-main {
  max-height: 600px;
  overflow: auto;
}
</style>